import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {gqlRoomParty} from '../getRoomParty.api';

export interface ChangeRoomLeaderInput {
    data: {
        room_party_member_id: number
    }
}

interface ChangeRoomLeaderData {
    changeRoomLeader: RoomParty
}

export const CHANGE_ROOM_LEADER_MUTATION = gql`
    mutation changeRoomLeader($data: ChangeRoomLeaderInput!) {
        changeRoomLeader(data: $data) {
            ${gqlRoomParty}
        }
    }
`;

export const changeRoomLeader = () => useMutation<ChangeRoomLeaderData, ChangeRoomLeaderInput>(
    CHANGE_ROOM_LEADER_MUTATION,
    {
        update: updateCacheByType('RoomParty'),
    }
);

export default changeRoomLeader;